import crm from "./crm";

const modeloImpressaoService = {
  buscarModelosImpressaoTicketPorProcesso: (idProcesso)=>{
    return crm.get(`/processo/${idProcesso}/modelos-impressao`);
  },
  getModelosDisponiveis: (idTipo, idTicket) => {
    return crm.get(`/ticket/buscar-modelos/${idTipo}/${idTicket}`);
  },
  getModeloImpressao: (idReferencia, idModelo, auxiliar=null) => {
    return crm.get(`/ticket/impressao/${idReferencia}/${idModelo}${auxiliar ? `/auxiliar/${auxiliar}` : ''}`);
  },
  gerarModeloImpressaoPorProcesso: (idProcesso, idTipoModelo, cpf=null) => {
    return crm.get(`/processo/${idProcesso}/impressao/${idTipoModelo}${cpf? `/cpf/${cpf}` : ''}`);
  },
};

export default modeloImpressaoService;
